import api from 'api';
import MenuItemCustomCategory from 'records/MenuItemCustomCategory'

export const MENU_ITEM_CUSTOM_CATEGORIES_ASYNC_ACTION_START = 'MENU_ITEM_CUSTOM_CATEGORIES_ASYNC_ACTION_START';
export const MENU_ITEM_CUSTOM_CATEGORIES_ASYNC_ACTION_ERROR = 'MENU_ITEM_CUSTOM_CATEGORIES_ASYNC_ACTION_ERROR';
export const MENU_ITEM_CUSTOM_CATEGORIES_ASYNC_ACTION_SUCCESS = 'MENU_ITEM_CUSTOM_CATEGORIES_ASYNC_ACTION_SUCCESS';
export const MENU_ITEM_CUSTOM_CATEGORIES_ASYNC_UPDATE_SUCCESS = 'MENU_ITEM_CUSTOM_CATEGORIES_ASYNC_UPDATE_SUCCESS';
export const MENU_ITEM_CUSTOM_CATEGORIES_RESET_STATE = 'MENU_ITEM_CUSTOM_CATEGORIES_RESET_STATE';
export const MENU_ITEM_CUSTOM_CATEGORIES_UPDATE_SUCCESS = 'MENU_ITEM_CUSTOM_CATEGORIES_UPDATE_SUCCESS';
export const MENU_ITEM_CUSTOM_CATEGORIES_DRAGGABLE_UPDATE = 'MENU_ITEM_CUSTOM_CATEGORIES_DRAGGABLE_UPDATE';
export const MENU_ITEM_CUSTOM_CATEGORIES_UPDATE_ORDINALS_SUCCESS = 'MENU_ITEM_CUSTOM_CATEGORIES_UPDATE_ORDINALS_SUCCESS';
export const MENU_ITEM_CUSTOM_CATEGORIES_ORDINALS_DEBOUNCE = 'MENU_ITEM_CUSTOM_CATEGORIES_ORDINALS_DEBOUNCE';

function menuItemCustomCategoriesAsyncActionStart() {
  return {
    type: MENU_ITEM_CUSTOM_CATEGORIES_ASYNC_ACTION_START,
  };
}

function menuItemCustomCategoriesAsyncActionError(error) {
  return {
    type: MENU_ITEM_CUSTOM_CATEGORIES_ASYNC_ACTION_ERROR,
    error,
  };
}

function menuItemCustomCategoriesAsyncActionSuccess(data) {
  return {
    type: MENU_ITEM_CUSTOM_CATEGORIES_ASYNC_ACTION_SUCCESS,
    data,
  };
}

function menuItemCustomCategoriesAsyncUpdateSuccess(data) {
  return {
    type: MENU_ITEM_CUSTOM_CATEGORIES_ASYNC_UPDATE_SUCCESS,
    data,
  };
}

function menuItemCustomCategoriesUpdateSuccess() {
  return {
    type: MENU_ITEM_CUSTOM_CATEGORIES_UPDATE_SUCCESS,
  };
}

function menuItemCustomCategoriesUpdateOrdinalsSuccess() {
  return {
    type: MENU_ITEM_CUSTOM_CATEGORIES_UPDATE_ORDINALS_SUCCESS,
  };
}

export function updateDraggableCategories(data) {
  return {
    type: MENU_ITEM_CUSTOM_CATEGORIES_DRAGGABLE_UPDATE,
    data,
  };
}

export function resetMenuItemCustomCategoriesState() {
  return {
    type: MENU_ITEM_CUSTOM_CATEGORIES_RESET_STATE,
  };
}

export function getMenuItemCustomCategoriesAsync(brandId, menuId) {
  return (dispatch, getState) => {
    dispatch(menuItemCustomCategoriesAsyncActionStart());
    return api.request(`usermenuitemcategory/list?brandId=${brandId}&menuId=${menuId}`, 'get')
    .then((data) => {
      dispatch(menuItemCustomCategoriesAsyncActionSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(menuItemCustomCategoriesAsyncActionError('Unable to get MenuItem Custom Categories List'));
      throw (err);
    });
  }
}

export function createMenuItemCustomCategoriesAsync(menuItemCustomCategories) {
  return (dispatch, getState) => {
    dispatch(menuItemCustomCategoriesAsyncActionStart());
    return api.request('usermenuitemcategory', 'post', menuItemCustomCategories)
    .then((data) => {
      dispatch(menuItemCustomCategoriesAsyncUpdateSuccess(data));
      return new MenuItemCustomCategory(data);
    })
    .catch((err) => {
      dispatch(menuItemCustomCategoriesAsyncActionError('Unable to create MenuItem Custom Category'));
      throw (err);
    });
  }
}

export function updateMenuItemCustomCategoriesAsync(menuItemCustomCategories) {
  return (dispatch, getState) => {
    dispatch(menuItemCustomCategoriesAsyncActionStart());
    return api.request('usermenuitemcategory', 'put', menuItemCustomCategories)
    .then((data) => {
      dispatch(menuItemCustomCategoriesAsyncUpdateSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(menuItemCustomCategoriesAsyncActionError('Unable to update MenuItem Custom Category'));
      throw (err);
    });
  }
}

export function deleteMenuItemCustomCategoriesAsync(userCategoryId) {
  return (dispatch, getState) => {
    dispatch(menuItemCustomCategoriesAsyncActionStart());
    return api.request(`usermenuitemcategory/${userCategoryId}`, 'delete')
    .then((data) => {
      dispatch(menuItemCustomCategoriesUpdateSuccess());
      return data;
    })
    .catch((err) => {
      dispatch(menuItemCustomCategoriesAsyncActionError('Unable to delete MenuItem Custom Category'));
      throw (err);
    });
  }
}

export function updateCategoriesOrdinal(orderedCategories) {
  const thunk = (dispatch, getState) => {
    
    return api.request('usermenuitemcategory/updateOrdinal', 'put', orderedCategories)
    .then((data) => {
      dispatch(menuItemCustomCategoriesUpdateOrdinalsSuccess());
      return data;
    })
    .catch((err) => {
      dispatch(menuItemCustomCategoriesAsyncActionError('Unable to order MenuItem Custom Categories'));
      throw (err);
    });
  };
  thunk.meta = {
    debounce: {
      time: 500,
      key: MENU_ITEM_CUSTOM_CATEGORIES_ORDINALS_DEBOUNCE,
    },
  };
  return thunk;
}
